var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdtIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4534 14.7671C29.4534 22.8797 22.877 29.4562 14.7645 29.4562C6.65191 29.4562 0.0754395 22.8797 0.0754395 14.7671C0.0754395 6.65459 6.65191 0.078125 14.7645 0.078125C22.8769 0.078125 29.4534 6.65459 29.4534 14.7671Z",
    fill: "#00A478"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2588 14.51V11.9403H9.77344V9.68774H19.513V11.972H16.0276V14.51H13.2588Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2749 14.7958C8.2749 13.9392 11.0763 13.2412 14.5617 13.2412C18.0471 13.2412 20.8484 13.9392 20.8484 14.7958C20.8484 15.6524 18.0471 16.3503 14.5617 16.3503C11.0763 16.3503 8.2749 15.6524 8.2749 14.7958ZM20.3272 14.7957C20.0992 14.4785 18.2099 13.495 14.5616 13.495C10.9133 13.495 9.02402 14.4468 8.796 14.7957C9.02402 15.113 10.9133 15.5889 14.5616 15.5889C18.2424 15.5889 20.0992 15.113 20.3272 14.7957Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0275 15.3032V13.5266C15.5714 13.4949 15.0828 13.4631 14.5942 13.4631C14.1382 13.4631 13.7147 13.4631 13.2913 13.4949V15.2715C13.6821 15.2715 14.1382 15.3032 14.5942 15.3032C15.0828 15.3349 15.5714 15.3349 16.0275 15.3032Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5615 16.3501C14.1055 16.3501 13.682 16.3501 13.2585 16.3183V21.0455H15.9948V16.2866C15.5387 16.3183 15.0501 16.3501 14.5615 16.3501Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtIcon);
export default __webpack_public_path__ + "static/media/usdt-icon.e9949a629fd12c6415ff65128f1dbdf7.svg";
export { ForwardRef as ReactComponent };